import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { PermissionUnauthorizedComponent } from './permission-unauthorized.component';
import { PermissionUnauthorizedRoutingModule } from './permission-unauthorized-routing.module';


@NgModule({
  declarations: [
    PermissionUnauthorizedComponent
  ],
  imports: [
    CommonModule,
    PermissionUnauthorizedRoutingModule,
    SharedModule,
  ]
})
export class PermissionUnauthorizedModule { }
